module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/00eb9f3a68e7def1267326fb86281a58.png";